import { useMutation } from "@tanstack/react-query"
import { psDelete } from "@/lib/powersync/crud"

export type DeleteSurveySitePayload = {
  id: string
  project_id: string
}

export const DELETE_SURVEY_SITE_MUTATION_KEY = ["surveySites", "delete"]

/**
 * Delete a survey site from PowerSync local SQLite.
 * PowerSync's uploadData syncs the delete to Supabase.
 */
export async function deleteSurveySiteFn(
  payload: DeleteSurveySitePayload,
): Promise<void> {
  await psDelete("survey_sites", payload.id)
}

export const useDeleteSurveySite = () => {
  return useMutation({
    mutationKey: DELETE_SURVEY_SITE_MUTATION_KEY,
    mutationFn: deleteSurveySiteFn,
    networkMode: "always",
  })
}
